import React, { useEffect } from "react";
import AllsecBanner from "../../components/common/AllsecBanner";
import ContactPage from "../../components/UserSideComponents/ContactPage/ContactPage";

const Contact = () => {
  useEffect(() => {
    // Scroll to top after initializing AOS
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <AllsecBanner title="Contact Us" />
      <ContactPage />
    </div>
  );
};

export default Contact;
